import React from 'react';
import { Link } from 'react-router-dom';

import { useNavigationUtils } from '@mssgme/hooks';
import { __t } from '@mssgme/shared';
import { usePageTheme, useSavedOrders } from '../../hooks';
import { ThemedModal } from '../../UI';

import styles from './UserOrdersPage.scss';

export function UserOrdersPage() {
    const { generateUrl } = useNavigationUtils();
    const { theme } = usePageTheme();
    const { userOrders } = useSavedOrders();
    const finalizedOrders = userOrders.filter((order) => order.finalized && order.feedback);
    const shouldRenderPaymentStatus = (provider, orderStatus) => {
        const immediate = ['cod', 'other'];

        return !immediate.includes(provider) && orderStatus !== 'rejected';
    };

    return (
        <ThemedModal overlay compact title={__t('my_orders')} onClose={generateUrl('..')} padding>
            <ul className={styles.ordersList}>
                {finalizedOrders.map((order) => (
                    <li key={order._id}>
                        <Link to={generateUrl(order._id)} style={theme.blocks.features}>
                            <div className={styles.orderHeader}>
                                <div>
                                    <h2>
                                        {__t('order_term')} #{order.feedback.order}
                                    </h2>
                                    <div>
                                        <span
                                            style={{
                                                color: theme.colors.background,
                                                backgroundColor: theme.colors.text,
                                            }}
                                        >
                                            {__t(`order_status_${order.feedback.status}`)}
                                        </span>
                                        {shouldRenderPaymentStatus(order.paymentMethod, order.feedback.status) && (
                                            <span
                                                style={{
                                                    color: theme.colors.background,
                                                    backgroundColor: theme.colors.text,
                                                }}
                                            >
                                                {__t(`payment_status_${order.status}`)}
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div>
                                    <div>
                                        <span>{new Date(order.feedback.timestamp).toLocaleDateString()}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.orderContent}>
                                <div>
                                    <h3>{__t('products')}</h3>
                                    <span>
                                        {order.items.map((item) => `${item.name} x${item.quantity}`).join(', ')}
                                    </span>
                                </div>
                                <div>
                                    {order.total.amount} {order.total.currency}
                                </div>
                            </div>
                        </Link>
                    </li>
                ))}
            </ul>
        </ThemedModal>
    );
}
